import {omit} from 'lodash';
import React from 'react';

import {type Ref} from '../../../state/views/filter/types';
import {usePart} from '../../../state/views/hooks';
import {WBAgentRunFilterContextSlice} from '../../WBAgent/collector/WBAgentContextSlices';
import {WBAgentSetFilterActionSlice} from '../../WBAgent/knownActions/WBAgentSetFilterActionSlice';
import {WBTableActionFilterButton} from '../WBTable/WBTableActionsFilter';

interface RunsFilterButtonProps {
  compact?: boolean;
  notificationOpen: boolean;
  filtersOpen: boolean;
  filtersRef: Ref;
  extraFilterCount?: number;
}

export const RunsFilterButton = (props: RunsFilterButtonProps) => {
  const filters = usePart(props.filtersRef);
  const passThroughProps = omit(
    props,
    'compact',
    'filtersOpen',
    'filtersRef',
    'extraFilterCount'
  );

  return (
    <>
      <WBAgentRunFilterContextSlice filters={filters} />
      <WBAgentSetFilterActionSlice filtersRef={props.filtersRef} />
      <WBTableActionFilterButton
        {...passThroughProps} // Required for use as popup trigger
        compact={props.compact}
        filtersOpen={props.filtersOpen}
        filters={filters}
        extraFilterCount={props.extraFilterCount}
      />
    </>
  );
};
